import React from 'react';
import { useContainer } from '../StoreProvider';
import styled from './index.module.scss';

function BottomTips() {
    const { protocol } = useContainer();
    const getContentTips = React.useMemo(() => protocol.flatMap(({ title, desc }) => [{ title }, ...desc.map((item) => ({ desc: item }))]), [protocol]);

    return (
        <div className={`${styled.BottomTips}`}>
            <div className="members-store-content">
                {getContentTips.map((item, index) => {
                    if ('title' in item && item.title) {
                        return <h2 key={index} dangerouslySetInnerHTML={{ __html: item.title }}></h2>;
                    }
                    return 'desc' in item && <p key={index} dangerouslySetInnerHTML={{ __html: item.desc }}></p>;
                })}
            </div>
        </div>
    );
}

export default BottomTips;
